var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet";
import getId from "@irati/utils/id";
import HeaderBalanceButtons from "./HeaderBalanceButtons";
import { StyledHeaderCard, InnerWrapper, ColumnWrapper, StyledCaption, AvailableBalance } from "../styled/HeaderBalance";
var RewardWalletHeaderBalance = /** @class */ (function (_super) {
    __extends(RewardWalletHeaderBalance, _super);
    function RewardWalletHeaderBalance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardWalletHeaderBalance.prototype.render = function () {
        var id = this.props.id;
        return (React.createElement(StyledHeaderCard, null,
            React.createElement(RewardWalletBalanceQuery, null, function (_a) {
                var data = _a.data;
                var _b = data.rewardWallet, availableBalance = _b.availableBalance, currency = _b.currency;
                var fractionDigits = availableBalance.toString().length > 8 ? 0 : 2;
                return (React.createElement(InnerWrapper, null,
                    React.createElement(ColumnWrapper, null,
                        React.createElement(StyledCaption, { flush: true },
                            React.createElement(FormattedMessage, { id: "wallet.reward.intro.available" })),
                        React.createElement(AvailableBalance, { id: getId("rewardWalletBalance", id) },
                            React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: availableBalance, minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }))),
                    React.createElement(ColumnWrapper, null,
                        React.createElement(HeaderBalanceButtons, { availableBalance: availableBalance }))));
            })));
    };
    return RewardWalletHeaderBalance;
}(PureComponent));
export default RewardWalletHeaderBalance;
